import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";
import { BsCameraVideoFill } from "react-icons/bs";
import { Player } from "video-react";
import { addStory } from "../service";
import "../../../../../node_modules/video-react/dist/video-react.css";
import { errorNotifier } from "../../../..";

export const VideoUploadModal = ({ videoFie, videoSrc, acctType, reload }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [loading, setLoading] = useState(false);

  const handleSendStory = async () => {
    const fileSize = videoFie.size / 1024 / 1024; // in MiB
    if (fileSize > 2) {
      errorNotifier("The file size is greater than 2MB");
      return;
    }

    const payload = {
      type: "video",
      file: videoFie,
    };
    setLoading(true);
    await addStory(payload, acctType, onClose, setLoading).then(() => reload());
  };

  return (
    <>
      <Flex justify={"center"} onClick={onOpen} cursor="pointer" width="100%">
        {" "}
        <BsCameraVideoFill color="#0276fc" size={22} />
      </Flex>
      <Modal isOpen={isOpen} onClose={onClose} size="sm" isCentered>
        <ModalOverlay />
        <ModalContent height={"370px"}>
          <ModalBody p="0px">
            <Flex
              direction={"column"}
              width="100%"
              height="330px"
              justify="start"
              align="start"
            >
              <Player
                playsInline
                src={videoSrc}
                fluid={false}
                width={"100%"}
                height={"100%"}
              />
            </Flex>
          </ModalBody>

          <Button
            _hover={{ background: "blue" }}
            color="#fff"
            isLoading={loading}
            onClick={handleSendStory}
            isDisabled={!videoFie}
            height="45px"
          >
            Done
          </Button>
        </ModalContent>
      </Modal>
    </>
  );
};
